var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1128_152770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 12V16.8C18 17.1183 17.8736 17.4235 17.6485 17.6485C17.4235 17.8736 17.1183 18 16.8 18H12",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 1.20001H20.4C21.0365 1.20001 21.647 1.45287 22.0971 1.90296C22.5471 2.35304 22.8 2.96349 22.8 3.60001V6.00001",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 7.2V6",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8 18V20.4C22.8 21.0365 22.5471 21.647 22.0971 22.0971C21.647 22.5471 21.0365 22.8 20.4 22.8H18",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19995 6.00001V3.60001C1.19995 2.96349 1.45281 2.35304 1.90289 1.90296C2.35298 1.45287 2.96343 1.20001 3.59995 1.20001H5.99995",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18H6.012",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99995 22.8H3.59995C2.96343 22.8 2.35298 22.5471 1.90289 22.0971C1.45281 21.647 1.19995 21.0365 1.19995 20.4V18",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 6H7.2C6.53726 6 6 6.53726 6 7.2V10.8C6 11.4627 6.53726 12 7.2 12H10.8C11.4627 12 12 11.4627 12 10.8V7.2C12 6.53726 11.4627 6 10.8 6Z",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1128_152770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/QRIcon.c261e6e0edd2ca152bc6e8f90614cd7e.svg";
export { ForwardRef as ReactComponent };